import { render, staticRenderFns } from "./SwatWalk.vue?vue&type=template&id=89341f7a&"
import script from "./SwatWalk.vue?vue&type=script&lang=js&"
export * from "./SwatWalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports